import { ReactNode, useState } from "react";
import { NotifyContext, NotifyContextType, NotifyType, Severity } from "./NotifyContext";

interface NotifyProviderProps {
	children: ReactNode;
}

export const NotifyProvider: React.FC<NotifyProviderProps> = ({ children }) => {
	const [notify, setNotifyState] = useState<NotifyType | null>(null);


	const setNotify = (notify: NotifyType | null) => {
		setNotifyState(notify);
	};

	const value: NotifyContextType = {
		notify,
		setNotify,
	};

	return <NotifyContext.Provider value={value}>{children}</NotifyContext.Provider>;
};
